import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const theme = createTheme({
  spacing: 8, // 1 unit = 8px (default, keep it clean)

  palette: {
    primary: {
      main: "#152259",
    },
  },

  typography: {
    fontFamily: "'Urbanist', sans-serif",
  },

  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingTop: "20px",
          paddingBottom: "10px",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          padding: "8px 24px",
          borderRadius: "24px",
          fontWeight: 600,
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "20px",
          padding: "24px",
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.04)",
    
          height: "100%",          // Important
          display: "flex",         // Important
          flexDirection: "column", // Important
    
          transition: "all 0.3s ease",
    
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0 20px 50px rgba(0,0,0,0.08)",
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();